webpackJsonp([350],{

/***/ 1005:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "VUX V2.1.1Rc.14 released | VUX - Vue.js Mobile UI Component Framework", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 1820:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1005),
  /* template */
  __webpack_require__(2201),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/home/runner/work/vux/vux/docs/node_modules/v-markdown-loader/_cache/v2.1.1-rc.14-80.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] v2.1.1-rc.14-80.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-45acc638", Component.options)
  } else {
    hotAPI.reload("data-v-45acc638", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2201:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.1.1Rc.14 released")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/checker.html"
    }
  }, [_vm._v("Checker")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] Now disabled item also emits event:on-item-click #1144")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/form-preview.html"
    }
  }, [_vm._v("FormPreview")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] Fix variable: form-preview-button-primary-color")]), _vm._v(" "), _c('li', [_vm._v("[feature] Support prop:name #1123")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/masker.html"
    }
  }, [_vm._v("Masker")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Support prop:fullscreen")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/selector.html"
    }
  }, [_vm._v("Selector")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] fix can not set Selector name attrbiute bug #1133")]), _vm._v(" "), _c('li', [_vm._v("[enhance] Selector value support Boolean. @rbao")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/swipeout.html"
    }
  }, [_vm._v("Swipeout")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] Fix left-menu is shown when sliding back and forth #1139")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/x-dialog.html"
    }
  }, [_vm._v("XDialog")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] Fix cannot set value to true initially #1138")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-45acc638", module.exports)
  }
}

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1820);

/***/ })

});


// WEBPACK FOOTER //
// 350.ba4282c8.js